import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useSeniorityFilter = ({ setFilters, seniorityOptions }) => {
  const formSchema = Yup.object().shape({
    seniority: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ seniority }) => {
    setFilters({ seniority: seniority || '' });
  };

  return {
    formSchema,
    onSubmit,
    seniorityOptions,
  };
};

useSeniorityFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  seniorityOptions: PropTypes.array.isRequired,
};
